import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 text-center" data-id="element-57">
      <div className="flex flex-col items-center" data-id="element-58">
        <div className="w-11 h-11 md:w-16 md:h-16 flex items-center justify-center bg-[#111827] border border-blue-500/30 rounded-lg text-lg md:text-2xl font-bold text-yellow-500 shadow-[0_0_15px_rgba(37,99,235,0.15)]" data-id="element-59">
          {format(timeLeft.hours)}
        </div>
        <span className="text-[8px] md:text-xs text-gray-400 mt-1 md:mt-2 uppercase tracking-wider" data-id="element-60">
          Horas
        </span>
      </div>
      <span className="text-lg md:text-2xl font-bold text-blue-500/50 -mt-4 md:-mt-6" data-id="element-61">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-62">
        <div className="w-11 h-11 md:w-16 md:h-16 flex items-center justify-center bg-[#111827] border border-blue-500/30 rounded-lg text-lg md:text-2xl font-bold text-yellow-500 shadow-[0_0_15px_rgba(37,99,235,0.15)]" data-id="element-63">
          {format(timeLeft.minutes)}
        </div>
        <span className="text-[8px] md:text-xs text-gray-400 mt-1 md:mt-2 uppercase tracking-wider" data-id="element-64">
          Minutos
        </span>
      </div>
      <span className="text-lg md:text-2xl font-bold text-blue-500/50 -mt-4 md:-mt-6" data-id="element-65">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-66">
        <div className="w-11 h-11 md:w-16 md:h-16 flex items-center justify-center bg-[#111827] border border-blue-500/30 rounded-lg text-lg md:text-2xl font-bold text-yellow-500 shadow-[0_0_15px_rgba(37,99,235,0.15)]" data-id="element-67">
          {format(timeLeft.seconds)}
        </div>
        <span className="text-[8px] md:text-xs text-gray-400 mt-1 md:mt-2 uppercase tracking-wider" data-id="element-68">
          Segundos
        </span>
      </div>
    </div>;
}